<template>
  <div class="box">
    <div class="head">
      <img
        class="returns"
        @click="returnBtn"
        src="../../assets/guild/return.png"
        alt=""
      />
      <p>{{ $t("prettyNumber.title") }}</p>
    </div>
    <div class="text">
      <div>{{ $t("prettyNumber.text") }}</div>
      <p class="txt2em">{{ $t("prettyNumber.text1") }}</p>
      <p class="txt2em">{{ $t("prettyNumber.text2") }}</p>
      <div>{{ $t("prettyNumber.title1") }}</div>
      <p class="txt2em">{{ $t("prettyNumber.text3") }}</p>
      <div>{{ $t("prettyNumber.title2") }}</div>
      <p class="txt2em">{{ $t("prettyNumber.text5") }}</p>
      <p class="txt2em">{{ $t("prettyNumber.text6") }}</p>
      <p class="txt2em">{{ $t("prettyNumber.text7") }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "App",
  components: {},
  data() {
    return {
      userInfo: [],
    };
  },
  created() {
    this.$completes.complete("getUserInfo");
    window.getUserInfo = this.getUserInfo;
    window["getUserInfo"] = (data) => {
      this.getUserInfo(data);
    };
  },
  mounted() {},
  methods: {
    getUserInfo(data) {
      this.userInfo = JSON.parse(data);
      let langs = this.userInfo.lang.substring(0, 2);
      let lang = this.userInfo.lang;
      if (langs == "zh") {
        if (lang == "zh_TW" || lang == "zh_HK") {
          this.$i18n.locale = "tc";
        } else {
          this.$i18n.locale = "zh";
        }
      } else if (langs == "en") {
        this.$i18n.locale = "en";
      } else if (langs == "ar") {
        this.$i18n.locale = "ar";
      } else if (langs == "tr") {
        this.$i18n.locale = "tr";
      } else if (langs == "es") {
        this.$i18n.locale = "es";
      } else if (langs == "pt") {
        this.$i18n.locale = "pt";
      } else {
        this.$i18n.locale = "en";
      }
      document.querySelector("html").setAttribute("lang", this.$i18n.locale);
    },

    returnBtn() {
      this.$completes.complete("getPreviousPage");
    },
  },
};
</script>
<style>
* {
  margin: 0;
  padding: 0;
}

.box {
  height: 100%;
  color: #ffffff;
  background-image: url("../../assets/download/laylabg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  overflow: scroll;
}

.head {
  height: 45px;
  display: flex;
  align-items: center;
  padding-top: 44px;
  padding-left: 15px;
  padding-right: 15px;
}
html[lang="ar"] .head {
  -webkit-transform: rotateY(180deg);
}

.returns {
  width: 0.6rem;
  height: 0.6rem;
}

.head p {
  flex: 1;
  font-size: 18px;
  text-align: center;
}

html[lang="ar"] .text {
  direction: rtl;
}

.text {
  padding: 0px 18px;
}

.text div {
  font-size: 17px;
  font-weight: 500;
  line-height: 30px;
  margin-top: 20px;
}

.text p {
  font-size: 15px;
  font-weight: 400;
  line-height: 25px;
}

.txt2em {
  text-indent: 2em;
}
</style>
